import React from "react";
import { Card, Icon, Typography, Box } from "@bca/ui-library";
import styled from "styled-components";
import { layout, LayoutProps } from "styled-system";

interface ErrorStateProps {
  icon: string;
  text: string;
  iconWeight?: "regular" | "solid" | "light";
}

const CardWithLayout = styled(Card)<LayoutProps>`
  ${layout}
`;

const ErrorState: React.FunctionComponent<ErrorStateProps> = ({
  icon,
  text,
  iconWeight = "regular",
}) => {
  return (
    <CardWithLayout
      width="100%"
      height={["188px", "188px"]}
      marginX={0}
      marginY={0}
      maxWidth={["100%", "60%", "648px"]}
    >
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Icon
          name={icon}
          weight={iconWeight}
          width={18}
          height={18}
          color="grey-blue"
        />
        <Typography variant="body" color="grey-blue" mt={1} mb={0}>
          {text}
        </Typography>
      </Box>
    </CardWithLayout>
  );
};

export default ErrorState;
